import React from 'react';

import RecordsTable from 'components/Grid/RecordsTable';

// The V5 SimpleGrid (Studio records Table) drawn by DataTable
// (dataTable gate): a records table sorted as configured, fitting its
// content or the gadget's width.
const SimpleGridDataTable = ({
  baseView,
  sort,
  gridSizing,
  setExportHandle,
}: {
  baseView: FleetOps.BaseView;
  sort: SimpleGridSort[];
  gridSizing?: SimpleGridConfig['gridSizing'];
  setExportHandle: (handle: DataTable.ExportHandle | undefined) => void;
}) => {
  const isFitContent = gridSizing === 'fitContent';
  return (
    <RecordsTable
      baseView={baseView}
      sort={sort}
      sizing={isFitContent ? 'fitContent' : 'fitWidth'}
      isFlexLayout={!isFitContent}
      onExportHandle={setExportHandle}
    />
  );
};

export default SimpleGridDataTable;
